var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('div',{staticClass:"col-xl-12"},[(_vm.$store.getters.language == 'zh')?[_c('cnContent')]:[_c('enContent')]],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }